import {useQuery} from "@tanstack/react-query";
import {useClientV2} from "../../../utils/hooks";
import {GetCustomerPastCallsApiResponse} from "./types";
import {PaginationMeta} from "../../../redux/service/i-service";
import {AxiosError} from "axios";
import {
  normalizeV2CustomerUpcomingCallsResponse,
  normalizeV2CustomerUpcomingCallsMeta,
} from "../upcoming-calls/upcoming-calls-normalizer";

export const customerPastCallsQueryKey = "customer_past_calls";
export const useGetCustomerPastCalls = (page: number = 1, per_page: number = 5) => {
  const client = useClientV2();

  return useQuery<
    {data: GetCustomerPastCallsApiResponse; meta: PaginationMeta},
    AxiosError<{status: boolean; message: string}>
  >({
    queryKey: [customerPastCallsQueryKey, {page}],
    queryFn: async () => {
      const response = await client(
        `customer/bookings/past?page=${page}&perPage=${per_page}`
      );
      const payload = response?.data ?? response;
      // Past and upcoming share the same v2 booking-list payload, so this
      // reuses the upcoming normalizer and only renames the collection key.
      return {
        data: {bookings: normalizeV2CustomerUpcomingCallsResponse(payload).session},
        meta: normalizeV2CustomerUpcomingCallsMeta(payload, page, per_page),
      };
    },
    keepPreviousData: true,
  });
};
